export const theme = {
    colors: {
        primary: '#2A71D4',
        white: '#ffffff',
        gray: '#333333',
        lightGray: '#515151',
        grayAlpha: "#333333de",
        lightGrayAlpha: '#515151de',
        darkBlueAlpha: '#062b5408',
        darkBlueAlphaMedium: '#062b548a',
        blue: '#062B54',
        paleBlue: '#F8FAFD',
        blackAlpha: '#0000004d'
    },
    spacing: 4,
    contentWidth: `${1280 - 24 * 2}`,

    chartsColors: {
        lightBlue: '#5CC0E8',
        orange: '#F7B500',
        mint: '#44D7B6',
        red: '#EA3100',
        lightRed: '#DA4200',
        lightOrange: '#F9B600'
    }
}
  